export default "__VITE_ASSET__BfQvYQ48__"